import { useMemo } from 'react';
import { sortBy } from 'lodash';

import firebase from '../../firebase';
import useCollectionSubscriptionInTenant from './useCollectionSubscriptionInTenant';
import { presetUserTags } from '../../shared/models/userTag';

const db = firebase.firestore();

export default function useUserTags() {
  const userTags = useCollectionSubscriptionInTenant(db.collection('userTags'));
  return useMemo(() => [...presetUserTags, ...sortBy(userTags, _ => _.createdAt?.toDate())], [userTags]);
}
